import {
  HotelReserveCategoriesPropertiesType,
  HotelReserveCategoryType
} from "@website/accommodation-ui/hotel-reserve-categories/hotel-reserve-categories.types";
import { Chips } from "@website/ui/chips";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { BaseSyntheticEvent, memo, useCallback } from "react";

const ItemComponent = ({ id, name }: HotelReserveCategoryType) => {
  const router = useRouter();
  const onClick = useCallback(
    (event: BaseSyntheticEvent) => {
      event.preventDefault();
      return router.push({
        pathname: "/[cityTitle]",
        query: {
          ...omit(router.query, "hotelTitle"),
          category_ids: id
        }
      });
    },
    [id, router]
  );
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <Chips
        text={numberConvert(name, { locale: router.locale })}
        variant="outline"
      />
    </div>
  );
};

const Component = ({ categories }: HotelReserveCategoriesPropertiesType) => {
  if (!categories?.length) return null;
  return (
    <div className="flex flex-col gap-4">
      <div className="text-subtitle-1 md:text-headline-6 mb-3">
        برچسب های این اقامتگاه
      </div>
      <div className="flex flex-row flex-wrap gap-2">
        {categories.map((category) => (
          <ItemComponent {...category} key={category.id} />
        ))}
      </div>
    </div>
  );
};
export const HotelReserveCategories = memo(Component, deepCompare);
